import { Deserializable } from '../protocols/deserializable';

export class AnnuityOperationalConversionRate implements Deserializable {
  public id!: number;
  public operationalRateId!: number;
  public month!: number;
  public rate!: number;

  public onDeserialize(): void {}
}
